import { render, staticRenderFns } from "./BuilderHeaderPrimary.vue?vue&type=template&id=2859459c&scoped=true&"
import script from "./BuilderHeaderPrimary.vue?vue&type=script&lang=js&"
export * from "./BuilderHeaderPrimary.vue?vue&type=script&lang=js&"
import style0 from "./BuilderHeaderPrimary.vue?vue&type=style&index=0&id=2859459c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859459c",
  null
  
)

export default component.exports